import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../../packages/react/src/drafts/Tooltip/Tooltip.docs.json';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`The Tooltip component is used to add context to interactive elements on the page.`}</p>
    <p><strong parentName="p"><em parentName="strong">{`⚠️ Usage warning! ⚠️`}</em></strong></p>
    <p>{`Tooltips as a UI pattern should be our last resort for conveying information because it is hidden by default and often with zero or little visual indicator of its existence.`}</p>
    <p>{`Before adding a tooltip, please consider: Is this information essential and necessary? Can the UI be made clearer? Can the information be shown on the page by default? See `}<a parentName="p" {...{
        "href": "https://primer.style/design/accessibility/tooltip-alternatives"
      }}>{`Tooltip alternatives`}</a>{` for more accessible alternatives.`}</p>
    <p>{`Tooltip should only be used on an element that is interactive such as a button or a link.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Default (For additional context)`}</h3>
    <p>{`Default tooltip is suitable for interactive controls that require additional context.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Tooltip text="This change cannot be undone.">
  <Button>Delete</Button>
</Tooltip>
`}</code></pre>
    <h3>{`As a label`}</h3>
    <p>{`Tooltip can be used to label interactive controls that has no visible text label such as interactive icon links.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Tooltip text="Contribution Documentation for 'Primer React'" type="label">
  <Link href="https://github.com/primer/react/contributor-docs/CONTRIBUTING.md" sx={{ml: 1, color: 'fg.muted'}}>
    <Octicon icon={BookIcon} sx={{color: 'fg.muted'}} />
  </Link>
</Tooltip>
`}</code></pre>
    <h3>{`With direction`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box sx={{padding: 5, display: 'flex', gap: '8px'}}>
  <Tooltip direction="n" text="Supplementary text">
    <Button>North</Button>
  </Tooltip>
  <Tooltip direction="s" text="Supplementary text">
    <Button>South</Button>
  </Tooltip>
  <Tooltip direction="e" text="Supplementary text">
    <Button>East</Button>
  </Tooltip>
  <Tooltip direction="w" text="Supplementary text">
    <Button>West</Button>
  </Tooltip>
  <Tooltip direction="ne" text="Supplementary text">
    <Button>North East</Button>
  </Tooltip>
  <Tooltip direction="nw" text="Supplementary text">
    <Button>North West</Button>
  </Tooltip>
  <Tooltip direction="se" text="Supplementary text">
    <Button>Southeast</Button>
  </Tooltip>
  <Tooltip direction="sw" text="Supplementary text">
    <Button>Southwest</Button>
  </Tooltip>
</Box>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      